import React from 'react';
import { Modal, Input, notification } from 'antd';
import { post } from '../../utils/http'
import api from '../../utils/api'

const { confirm } = Modal;

export default function CreateNewMenu(props) {
    const [dictCode, setDictCode] = React.useState(props.editValue.dictCode);
    const [dictName, setDictName] = React.useState(props.editValue.dictName);
    const [typeCode, setTypeCode] = React.useState(props.editValue.typeCode);
    const [typeName, setTypeName] = React.useState(props.editValue.typeName);
    const [orderNo, setOrderNo] = React.useState(props.editValue.orderNo);
    const [confirmLoading, setConfirmLoading] = React.useState(false); 


    const handleSubmit = () => {//submit button
        setConfirmLoading(true)
        const editData = {
            dictId: props.editValue.dictId,
            dictCode,
            dictName,
            typeCode,
            typeName,
            orderNo
        }
        post(api.saveAndUpdateDict, editData).then(function (response) {

            notification['success']({
                message: 'Update successfully.',
            });
            props.closeEditModal();
            props.handleSearch();
            setConfirmLoading(false)
        }).catch(function (error) {
            notification['error']({
                message: 'Fail to update.',
            });
            setConfirmLoading(false)
            console.log("@error", error)
        })

        props.closeEditModal()
    }

    const handleCancle = () => {
        confirm({
            content: "Are you sure to close this modal?",
            onOk() {
                Modal.destroyAll();
                props.closeEditModal();
            }
        });
    };

    return (
        <>
            <Modal
                title="Edit Dict"
                visible={props.isOpenEdit}
                onOk={handleSubmit}
                confirmLoading={confirmLoading}
                onCancel={handleCancle}
            >
                    <div style={{ display: "flex" }}>
                        <p style={{ width: "150px", lineHeight: "36px" }}>Dictionary Name </p>
                        <Input value={dictName} placeholder="dictionary name" onChange={event => setDictName(event.target.value)} style={{ height: "36px", width: "310px" }} />
                    </div>

                    <div style={{ display: "flex" }}>
                        <p style={{ width: "150px", lineHeight: "36px" }}>Dictionary Code </p>
                        <Input value={dictCode} placeholder="dictionary code" onChange={event => setDictCode(event.target.value)} style={{ height: "36px", width: "310px" }} />
                    </div>

                    <div style={{ display: "flex" }}>
                        <p style={{ width: "150px", lineHeight: "36px" }}>Type Name</p>
                        <Input value={typeName} placeholder="type name" onChange={event => setTypeName(event.target.value)} style={{ height: "36px", width: "310px" }} />
                    </div>

                    <div style={{ display: "flex" }}>
                        <p style={{ width: "150px", lineHeight: "36px" }}>Type Code </p>
                        <Input value={typeCode} placeholder="type code" onChange={event => setTypeCode(event.target.value)} style={{ height: "36px", width: "310px" }} />
                    </div>

                    <div style={{ display: "flex" }}>
                        <p style={{ width: "150px", lineHeight: "36px" }}>Order Number </p>
                        <Input value={orderNo} placeholder="order number" onChange={event => setOrderNo(event.target.value)} style={{ height: "36px", width: "310px" }} />
                    </div>
            </Modal>
        </>
    );
}